import { AppstoreOutlined, BellOutlined, BarChartOutlined, LineChartOutlined, MenuOutlined } from '@ant-design/icons'
import {
  ACCOUNT_PAGE, ALARM_HISTORY, ALARM_HISTORY_SUMMARY, UPTIME_HISTORY,
  SETTINGS_PAGE, MANAGEMENT_PAGE, DEVICES_DASHBOARD, UPDATE_LOGS,
} from '../../configuration/paths'

// Single source of truth for the primary nav, shared by the desktop top bar and the
// mobile bottom tabs so they can never drift. Role/isSysAdmin gating lives here.
export const getNavItems = (role, isSysAdmin) => {
  const tabs = [
    { key: ACCOUNT_PAGE, label: 'Dashboard', icon: <AppstoreOutlined /> },
    { key: ALARM_HISTORY, label: 'Alerts', icon: <BellOutlined /> },
    { key: ALARM_HISTORY_SUMMARY, label: 'Summary', icon: <BarChartOutlined /> },
    ...(role !== 'user' ? [{ key: UPTIME_HISTORY, label: 'Metrics', icon: <LineChartOutlined /> }] : []),
    { key: '__more__', label: 'More', icon: <MenuOutlined /> },
  ]

  // `desktop: true` → the target page is desktop-oriented; the mobile More sheet tags it.
  const moreRows = [
    { key: SETTINGS_PAGE, label: 'Settings' },
    ...(isSysAdmin ? [{ key: UPDATE_LOGS, label: 'Device Update Logs' }] : []),
    ...(role !== 'user' && role !== 'analyst' ? [{ key: MANAGEMENT_PAGE, label: 'Management', desktop: true }] : []),
    ...(role === 'special' ? [{ key: DEVICES_DASHBOARD, label: 'RAD Dashboard', desktop: true }] : []),
  ]

  return { tabs, moreRows }
}
